import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useSubscription } from "@/contexts/SubscriptionContext";
import { formatProMonthlyPrice } from "@/lib/pricing";
import { cn } from "@/lib/utils";

interface UpgradeBannerProps {
  className?: string;
}

export function UpgradeBanner({ className = "" }: UpgradeBannerProps) {
  const { isPaid, loading } = useSubscription();

  if (loading || isPaid) {
    return null;
  }

  return (
    <div className={cn("rounded-lg border border-blue-200 bg-blue-50 p-4", className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-white">
            <Sparkles className="h-5 w-5 text-blue-600" strokeWidth={2} />
          </div>
          <div>
            <p className="text-label text-neutral-900">Assine para praticar</p>
            <p className="mt-1 text-caption text-neutral-500">
              Conversas liberadas por {formatProMonthlyPrice()}/mês
            </p>
          </div>
        </div>
        <Link
          to="/app/upgrade"
          className="whitespace-nowrap text-label text-blue-600 hover:text-blue-700"
        >
          Assinar
        </Link>
      </div>
    </div>
  );
}
